import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const ToastContainerWrapper: React.FC = () => {
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                toastStyle={{ borderRadius: "16px", padding: "12px" }}
                closeButton={<span className="material-symbols-rounded">close</span>}
                toastClassName="CustomToast"
            />
        </>
    );
};

export default ToastContainerWrapper;
